import { FC } from "react";
import { IconPropsType } from ".";

export const EllipsisVertical: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 2C3.5 2.82838 2.82838 3.5 2 3.5C1.17162 3.5 0.5 2.82838 0.5 2C0.5 1.17162 1.17162 0.5 2 0.5C2.82838 0.5 3.5 1.17162 3.5 2Z"
        fill={props.color}
      />
      <path
        d="M3.5 7C3.5 7.82838 2.82838 8.5 2 8.5C1.17162 8.5 0.5 7.82838 0.5 7C0.5 6.17162 1.17162 5.5 2 5.5C2.82838 5.5 3.5 6.17162 3.5 7Z"
        fill={props.color}
      />
      <path
        d="M3.5 12C3.5 12.8284 2.82838 13.5 2 13.5C1.17162 13.5 0.5 12.8284 0.5 12C0.5 11.1716 1.17162 10.5 2 10.5C2.82838 10.5 3.5 11.1716 3.5 12Z"
        fill={props.color}
      />
    </svg>
  );
};
